/*
   eslint-disable
   import/extensions,
   import/no-unresolved,
   import/prefer-default-export,
*/
// Local
import store from '@/store'
import { bootstrapStorageManager as bootstrapFirestore } from './firestore.storage-manager'
import { bootstrapStorageManager as bootstrapCloudStorage } from './cloud-storage.storage-manager'

/**
 * Storage backend from tenant feature flags (featureFlags.PAGE_STORAGE_BACKEND).
 * Must match config/managers/storage-manager.js type.
 * - firestore: legacy (currentPage.data.recipes) — default for progressive migration
 * - google-cloud-storage: new (Cloud Storage data.json, index.html, styles.css)
 */
function getStorageBackend() {
  const featureFlags = store.getters['tenant/getFeatureFlags'] || {}
  return featureFlags.PAGE_STORAGE_BACKEND || 'firestore'
}

/**
 * Bootstraps the Storage Manager by delegating to the selected backend.
 *
 * @param {*} editor - The editor object.
 * @param {*} insertedPage - The current page object.
 *
 * @returns {void}
 */
export function bootstrapStorageManager(editor, insertedPage) {
  if (getStorageBackend() === 'google-cloud-storage') {
    bootstrapCloudStorage(editor, insertedPage)
  } else {
    bootstrapFirestore(editor, insertedPage)
  }
}
